import { baseApi, API_TAGS } from '@/shared/api';
import {
  createDashboardEndpointBuilder,
  type DashboardOptions,
  type TransportResponse,
  type TransportsEnRouteResponse
} from '@/entities/dashboard';

const transportEndpoint = createDashboardEndpointBuilder('/transport', '/api/v2/dashboard');

export const transportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransport: builder.query<TransportResponse, DashboardOptions | undefined>({
      query: (options) => ({
        url: transportEndpoint(''),
        params: options
      }),
      providesTags: [API_TAGS.DASHBOARD, API_TAGS.TRANSPORT]
    }),

    getTransportsEnRoute: builder.query<TransportsEnRouteResponse, DashboardOptions | undefined>({
      query: (options) => ({
        url: transportEndpoint('/en-route'),
        params: options
      }),
      providesTags: [API_TAGS.DASHBOARD, API_TAGS.TRANSPORT]
    })
  })
});

export const { useGetTransportQuery, useGetTransportsEnRouteQuery } = transportApi;
